export const SEND_SMS_REQUEST = 'SEND_SMS_REPORT_REQUEST';
export const SEND_SMS_SUCCESS = 'SEND_SMS_REPORT_SUCCESS';
export const SEND_SMS_FAILURE = 'SEND_SMS_REPORT_FAILURE';
export const SEND_SMS_REQUEST_SUCCESS = 'SEND_SMS_REPORT_REQUEST_SUCCESS';
export const SEND_SMS_REQUEST_FAILURE = 'SEND_SMS_REPORT_REQUEST_FAILURE';
export const SEND_SMS_MAIL_WHATSAPP_REQUEST = 'SEND_SMS_REPORT_MAIL_WHATSAPP_REQUEST';
export const SEND_SMS_MAIL_WHATSAPP_SUCCESS = 'SEND_SMS_REPORT_MAIL_WHATSAPP_SUCCESS';

// new (for one-by-one progress)
export const SEND_ONE_SUCCESS = 'SEND_ONE_SUCCESS';
export const SEND_ONE_FAILURE = 'SEND_ONE_FAILURE';
export const SET_SEND_TOTAL = 'SET_SEND_TOTAL';
export const SET_SENDING = 'SET_SENDING';
export const RESET_SEND_PROGRESS = 'RESET_SEND_PROGRESS';